<!--实时电能质量,三相电压和不平衡度-->
<template>
	<div class="virtualDeviceRTCurveBody">
		<!--日期弹窗-->
		<elCheckBoxTree slot="tree" :dataList='virtualDeviceList'></elCheckBoxTree>
		<div class="pageBody" slot="body">
			<div class="buttonLine">
				<label>应用类型组：</label>
				<el-select v-model="apptypeValue" multiple collapse-tags placeholder="请选择" size='small'>
					<el-option label='全选' value='全选' @click.native='selectAll'></el-option>
					<el-option v-for="item in apptypeGroups" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</div>
			<!--图表-->
			<vchart ref='vchart' style="height: calc(65% - .37rem)"></vchart>
			<!--表格显示数据-->
			<el-table height="29%" :data="nowPage" border highlight-current-row :header-cell-style="{background:'#F5F5F5',color:'#696969'}">
				<el-table-column type="index" width="50"></el-table-column>
				<el-table-column v-for='item in columns' :prop="item.key" align='center' :label="item.name" :key="item.key"></el-table-column>
			</el-table>
			<div style="width: 98%;display: flex;align-items: center;justify-content: flex-end;height: 5%;">
				<el-pagination
				@current-change='nowIndex = $event - 1'
				:page-size="pageLen"
				layout="total, prev, pager, next, jumper"
				:total="dataList.length">
				</el-pagination>
			</div>
     	</div>
	</div>
</template>

<script>
	import vchart from '@/components/module/chart/vchart.vue'
	import infoList from '@/components/module/universal/infoList.vue'
	import elCheckBoxTree from '@/components/module/tree/elCheckBoxTree.vue'
	export default {
		components: {
			vchart,
			//infoList,
			elCheckBoxTree,
		},
		props: {},
		data() {
			return {
				apptypeValue: [],
				nowIndex: 0,
				from2name: {},
				nowApptypeGroups: [],
				nowSeries: [],
				refreshInterval: 2000,
				columns: [{
					name: '设备名称',
					key: 'devicename'
				}, {
					name: '变量名称',
					key: 'variablename'
				}, {
					name: '实时值',
					key: 'value'
				}],
				options: {
					title: {
						text: "实时曲线",
						left: 'center',
						textStyle: {
							fontWeight: 800,
							fontSize: 22,
						}
					},
					tooltip: {
						trigger: 'axis',
						confine: true,
						formatter: (params, ticket, callback) => {
							var label = new Date(params[0].data[0]).formatByTime() + "</br>"
							params.forEach(item => {
								var values;
								if(isnull(item.data[1])) {
									values = "无采集数据";
								} else {
									values = cutDigital(item.data[1]);
								}
								label += item.seriesName + " : " + values + "</br>"
							})
							return label;
						},
						axisPointer: {
							animation: false
						}
					},
					xAxis: {
						type: 'time',
						splitLine: {
							show: true
						}
					},
					yAxis: {
						type: 'value',
						max: value => {
								return Math.ceil(value.max) | 0 + 10
						},
						boundaryGap: [0, '100%'],
						splitLine: {
							show: true
						}
					},
					grid: {
						left: '5%',
						right: '5%',
						bottom: '70'
					},
					legend: {
						data: [],
						type: 'scroll',
						bottom: '20px',
						right:30,
						formatter: function(name) {
							return echarts.format.truncateText(name, 100, '14px Microsoft Yahei', '…');
						},
						tooltip: {
							show: true
						},
						selected: {}
					},
					series: []
				}
			}
		},
		created() {},
		mounted() {
			debugPage = this
			this.$refs.vchart.setData(this.options, true)
			addNewTask('refreshRealPowerQuality', 1000, this.refreshInterval, -1, () => {
				this.addData()
			})
			this.apptypeValue = this.nowSelectAppTypeGroupIds
		},
		destroyed() {
			removeTask('refreshRealPowerQuality')
			this.realTimeValueStore.commit("removeKeys", this.variableNameList)
		},
		computed: {
			nowVirtualDeviceList() {
				return this.$store.deviceStore.state.nowVirtualDeviceList
			},
			nowSelectAppTypeGroupIds() {
				return this.$store.cacheStore.getters.getNowSelectAppTypeGroupIds(this.apptypeGroups)
			},
			getBackgroudImageStyle() {
				return this.$store.resourcesStore.getters.getBackgroudImageStyle
			},
			getResourcesByName() {
				return this.$store.resourcesStore.getters.getResourcesByName
			},
			variableStore() {
				return this.$store.variableStore
			},
			archivesStore() {
				return this.$store.archivesStore
			},
			deviceStore() {
				return this.$store.deviceStore
			},
			virtualDeviceList() {
				var data = this.$store.deviceStore.getters.getReadDeviceTree
				return isempty(data) ? [] : [deviceList(data)]
			},
			realTimeValueStore() {
				return this.$store.realTimeValueStore
			},
			variableTree() {
				if(this.nowVirtualDeviceList == undefined || isempty(this.nowVirtualDeviceList)) {
					return []
				}
				var variableTreeArr = []
				this.nowVirtualDeviceList.forEach(item => {
					var variableTree=[]
					if(item.type=="virtualDevice"){
						variableTree = this.variableStore.getters.getVariableTree(item.no)
					}
					variableTree.forEach(tree => {
						tree.devicename = item.name
					})
					variableTreeArr.push(variableTree)
				})
				var result = []
				variableTreeArr.forEach(item => {
					result = result.concat(item)
				})
				return result
			},
			apptypeGroups() {
				//所有已选中的设备所具有的变量类型组
				var list = []
				var apptypeGroupIds = []
				this.variableTree.forEach(apptypeGroup => {
					if(!apptypeGroupIds.includes(apptypeGroup.id)) {
						apptypeGroupIds.push(apptypeGroup.id)
						list.push(apptypeGroup)
					}
				})
				//排序
				return list.sort((a, b) => {
					return a.serialnum - b.serialnum
				})
			},
			variableNameList() {
				//当前应该显示的变量fromname列表
				var ag = this.nowApptypeGroups.map(item => {
					return item.id
				})
				var v1 = this.variableTree.filter(item => {
					return ag.includes(item.id)
				})
				if(isempty(v1)) {
					return []
				}
				var v2 = []
				v1.forEach(item => {
					item.next.forEach(i => {
						this.from2name[i.fromName] = i.name + '(' + item.unit + ')'
						v2.push(i.fromName) 
					})
				})
				return v2
			},
			nowVariableList() {
				//当前应该显示的变量fromname列表
				var ag = this.nowApptypeGroups.map(item => {
					return item.id
				})
				var v1 = this.variableTree.filter(item => {
					return ag.includes(item.id)
				})
				if(isempty(v1)) {
					return []
				}
				var v2 = []
				v1.forEach(item => {
					item.next.forEach(i => {
						i.devicename = item.devicename
						v2.push(i)
					})
				})
				v2.sort((a, b) => {
					return a.typeNo - b.typeNo
				})
				return v2
			},
			pageLen() {
				return this.dataList.length < 20 ? this.dataList.length : 20
			},
			nowPage() {
				// 按照页码来返回当前应该显示的列表
				var list = this.dataList.filter((item, index) => {
					return index >= this.nowIndex * this.pageLen && index < (this.nowIndex + 1) * this.pageLen
				})
				return list
			},
			dataList() {
				//获取值
				var vl = this.realTimeValueStore.getters.getValue(this.variableNameList)
				return this.variableNameList.map((item, index) => {
					var value = this.realTimeValueStore.getters.getText(item, vl[index])
					if(isNaN(parseFloat((value))) || isnull(parseFloat((value)))) {
						value = '- -'
					}
					var name = this.from2name[item] ? this.from2name[item] : item
					let deviceName = ''
					this.nowVariableList.forEach(item2 => {
						if(item2.fromName == item) {
							deviceName = item2.fromName.split('.')[0]
						}
					})
					return {
						devicename: deviceName,
						variablename: name.subByFirstChar("."),
						value, 
					}
				})

			}
		},
		watch: {
			variableNameList(nv, ov) {
				this.realTimeValueStore.commit("removeKeys", ov)
				this.realTimeValueStore.commit("addKeys", nv)
				//重置缓存数据
				var list = []
				var dataList = []
				var now = new Date().getTime()
				for(var i = 0; i < 20; i++) {
					dataList.unshift([now - this.refreshInterval * i, undefined])
				}
				nv.forEach((item, index) => {
					let deviceName = ''
					this.nowVariableList.forEach(item2 => {
						if(item2.fromName == item) {
							deviceName = item2.fromName.split('.')[0]
						}
					})
					var name = deviceName + "_" + item.subByFirstChar('.')
					list.push({
						name,
						fromName: item,
						type: 'line',
						markPoint: {
							data: [{
								name: '最大值',
								type: 'max'
							}]
						},
						symbol: 'emptyCircle',
						data: dataList.copy()
					})
				})
				this.nowSeries = list
				this.options.series = list
				var selected = {}
				this.options.legend.data =
					nv.map((item, index) => {
						let deviceName = ''
						this.nowVariableList.forEach(item2 => {
							if(item2.fromName == item) {
								deviceName = item2.fromName.split('.')[0]
							}
						})
						var name = deviceName + "_" + item.substr(item.indexOf('.') + 1)
						if(index > 5) {
							selected[name] = false
						}
						return {
							name: name,
							icon: 'roundRect'
						}
					})
				this.options.legend.selected = selected
				this.$refs.vchart.setData(this.options, true)
			},
			apptypeValue(nv, ov) {
				this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds', nv)
				let list = []
				if(!isempty(nv)) {
					nv.forEach(item => {
						this.apptypeGroups.forEach(item2 => {
							if(item == item2.id) {
								list.push(item2)
							}
						})
					})
				}
				this.nowApptypeGroups = list
			}
		},
		methods: {
			selectAll() {
				//全选 先判断是否有选中的，有选中就清空
				if(this.apptypeValue.length==1) {
					this.nowApptypeGroup = this.apptypeGroups
					let idList = []
					this.apptypeGroups.forEach(item => {
						idList.push(item.id)
					})
					this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds', idList)
					this.apptypeValue = idList
				}else{
					this.nowApptypeGroup =[]
					this.$store.cacheStore.commit('setNowSelectAppTypeGroupIds', [])
					this.apptypeValue=[]
				}
			},
			addData() {
				//获取值
				if(this.$refs.vchart == undefined) {
					return
				}
				var vl = this.realTimeValueStore.getters.getValue(this.variableNameList)
				var now = new Date().getTime()
				this.nowSeries.forEach((item, index) => {
					item.data.shift()
					var temp = vl[index]
					if(isNaN(parseFloat((temp))) || isnull(parseFloat((temp)))) {
						temp = undefined
					}
					item.data.push([now, temp])
				})
				this.$refs.vchart.setData({
					series: this.nowSeries
				})
			}
		}
	}
</script>

<style scoped>
	.pageBody {
		width: 100%;
		height: 100%;
		padding-bottom: 60px;
		padding-top: 75px;
	}
	
	.virtualDeviceRTCurveBody {
		width: 100%;
		display: flex !important;
		align-items: center;
		justify-content: space-between;
		background-color: white;
	}
</style>
